import React from "react";

import { WorkflowStagesDialog } from "#app/components/stages/workflow-stages-dialog";
import { createDialogEmitter } from "#app/lib/dialog-emitter";

type StagesDialogActions = {
  /** Open the stage manager for one workflow. */
  openStagesDialog: (workflowId: string) => void;
  closeStagesDialog: () => void;
};

const stagesDialog = createDialogEmitter<string>("stages");

/** Get stable open/close callbacks. Works inside bottom-sheet portals. */
export function useStagesDialogActions(): StagesDialogActions {
  return React.useMemo<StagesDialogActions>(
    () => ({ openStagesDialog: stagesDialog.open, closeStagesDialog: stagesDialog.close }),
    [],
  );
}

export function StagesDialogMount() {
  const { open, payload: workflowId } = stagesDialog.useDialogState();
  return (
    <WorkflowStagesDialog
      workflowId={open ? workflowId : null}
      open={open}
      onClose={stagesDialog.close}
    />
  );
}
